import {
  Option,
  SearchAutocomplete,
  Select,
} from "@deere/fuel-react";
import {
  Input,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React, { useEffect } from "react";
import { WON } from "../../utilities/constants";
import { updateDecimalInputOnState } from "../../utilities/tp-validations";
import TableStyleUtility from "../TransactionUtility/connected-table-style-utility-bar";

function CompetitorInformation(props) {
  const setMachine = function (machine) {
    if (machine) {
      const arrOfMachine = machine.split("_");
      props.setBidsTextValue("model", arrOfMachine[0], "JD");
      props.transactions.bids.forEach((bid) => {
        props.setBidsTextValue("category", arrOfMachine[1], bid.bidType);
      });
    }
  };

  const compBids = parseInt(props.transactions.compBids, 10);

  useEffect(() => {
    props.setBidsTextValue("make", "John Deere");
    props.setBidsTextValue("dealResult", props.bids["dealResult"]);
  }, []);

  return (
      <TableContainer variant="outlined">
        <Table
            striped
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            size={"small"}
        >
          <TableStyleUtility />
          <TableBody>
            <TableRow hover key="Result" id={"Result"}>
              <TableCell classes="tableBorder" styles={{ border: "black" }}>
                <InputLabel required>{props.texts.RESULT}</InputLabel>
              </TableCell>
              <TableCell styles={{ border: "solid black 2px" }} align="center">
                <InputLabel readOnly={props.actionType.action === "view"}>
                  {props.transactions &&
                  props.transactions.bids[0] &&
                  props.transactions.bids[0].dealResult
                      ? props.transactions.bids[0].dealResult === WON
                          ? props.texts.WON
                          : props.texts.LOST
                      : ""}
                </InputLabel>
              </TableCell>
              {Array(compBids)
                  .fill(null)
                  .map((value, index) =>
                      props.transactions &&
                      props.transactions.bids[0] &&
                      props.transactions.bids[0].dealResult &&
                      props.transactions.bids[0].dealResult === WON ? (
                          <TableCell align="center">
                            <InputLabel
                                readOnly={props.actionType.action === "view"}
                                onInput={(e) =>
                                    props.setBidsTextValue(
                                        "dealResult",
                                        "Lost",
                                        `C${index + 1}`
                                    )
                                }
                            >
                              {props.texts.LOST}
                            </InputLabel>
                          </TableCell>
                      ) : (
                          <TableCell align="center">
                            <Select
                                value={props.transactions.bids[index + 1].dealResult}
                                readOnly={props.actionType.action === "view"}
                                onChange={(e) => {
                                  props.setBidsTextValue(
                                      "dealResult",
                                      e.target.value,
                                      `C${index + 1}`
                                  );
                                }}
                            >
                              {props.domainDetails &&
                              props.domainDetails["RESULT"].length > 0 &&
                              props.domainDetails["RESULT"].map((value, index) => {
                                return (
                                    <Option key={index} value={value.domainValue}>
                                      {value.domainValue}
                                    </Option>
                                );
                              })}
                            </Select>
                          </TableCell>
                      )
                  )}
            </TableRow>

            <TableRow hover key="Dealership Name" id={"Dealership Name"}>
              <TableCell>
                <InputLabel>{props.texts.DEALERSHIP_NAME}</InputLabel>
              </TableCell>
              <TableCell align="center">
                <InputLabel readOnly={props.actionType.action === "view"}>
                  {props.transactions && props.transactions.bids[0].dealerName}
                </InputLabel>
              </TableCell>

              {Array(compBids)
                  .fill(null)
                  .map((value, index) => (
                      <TableCell align="center">
                        <Input
                            readOnly={props.actionType.action === "view"}
                            type={"text"}
                            fullWidth
                            id="dealerName"
                            placeholder=""
                            value={props.transactions.bids[index + 1].dealerName}
                            onChange={(e) =>
                                props.setBidsTextValue(
                                    "dealerName",
                                    e.target.value,
                                    `C${index + 1}`
                                )
                            }
                        />
                      </TableCell>
                  ))}
            </TableRow>
            <TableRow hover key="Manufacturer" id={"Manufacturer"}>
              <TableCell>
                <InputLabel>{props.texts.MANUFACTURER}</InputLabel>
              </TableCell>
              <TableCell align="center">
                <InputLabel>{props.texts.JOHN_DEERE}</InputLabel>
              </TableCell>
              {Array(compBids)
                  .fill(null)
                  .map((value, index) => (
                      <TableCell align="center">
                        <SearchAutocomplete
                            readOnly={props.actionType.action === "view"}
                            options={
                              props.domainDetails["COMP_MAKE"]?.map((make) => ({
                                label: make.domainValue,
                              })) || []
                            }
                            style={{
                              border:
                                  props.errorFields.length !== 0 &&
                                  props.transactions.bids[index+1].make === ""
                                      ? "1px solid #c21020"
                                      : null,
                            }}
                            value={props.transactions.bids[index + 1].make}
                            InputProps={{
                              placeholder: props.texts.ENTER_COMP_MFR,
                            }}
                            onChange={(e, v, reason) => {
                              if (reason && reason === "clear") {
                                props.setBidsTextValue("make", "", "JD");
                                props.transactions.bids.forEach((bid) => {
                                  props.setBidsTextValue("make", "", bid.bidType);
                                });
                              }
                              try {
                                props.setBidsTextValue(
                                    "make",
                                    v.label,
                                    `C${index + 1}`
                                );
                              } catch (e) {}
                            }}
                        />
                      </TableCell>
                  ))}
            </TableRow>
            <TableRow hover key="Model" id={"Model"}>
              <TableCell>
                <InputLabel required={true}>{props.texts.MODEL}</InputLabel>
              </TableCell>
              <TableCell align="center">
                <SearchAutocomplete
                    readOnly={props.actionType.action === "view"}
                    style={{
                      border:
                          props.errorFields.length !== 0 &&
                          props.transactions.bids[0].model === ""
                              ? "1px solid #c21020"
                              : null,
                    }}
                    label={props.texts.MCHN}
                    value={
                      props.transactions.bids[0].model +
                      " " +
                      props.transactions.bids[0].category
                    }
                    onChange={(e, v, reason) => {
                      if (reason && reason === "clear") {
                        props.setBidsTextValue("model", "", "JD");
                        props.transactions.bids.forEach((bid) => {
                          props.setBidsTextValue("category", "", bid.bidType);
                        });
                      } else if (v && v.value) {
                        try {
                          setMachine(v.value);
                        } catch (e) {}
                      }
                    }}
                    options={props.machines}
                    InputProps={{
                      placeholder: props.texts.PLS_ETR_JD_MODEL,
                    }}
                />
              </TableCell>
              {Array(compBids)
                  .fill(null)
                  .map((value, index) => (
                      <TableCell align="center">
                        <Input
                            type={"text"}
                            fullWidth
                            id="CompModel"
                            readOnly={props.actionType.action === "view"}
                            value={props.transactions.bids[index + 1].model}
                            error={
                              props.errorFields.length !== 0 &&
                              props.transactions.bids[index + 1].model === ""
                            }
                            placeholder={props.texts.ENT_COMP_MODEL}
                            onChange={(e) =>
                                props.setBidsTextValue(
                                    "model",
                                    e.target.value,
                                    `C${index + 1}`
                                )
                            }
                        />
                      </TableCell>
                  ))}
            </TableRow>

            <TableRow
                hover
                key="Sale / Quote Amount ($)"
                id={"Sale / Quote Amount ($)"}
            >
              <TableCell>
                <InputLabel required={true}>
                  {props.texts.SALE_QUOTE_AMOUNT}
                </InputLabel>
              </TableCell>
              <TableCell align="center">
                <Input
                    type={"text"}
                    fullWidth
                    id="jdSaleAmount"
                    readOnly={props.actionType.action === "view"}
                    error={
                      props.errorFields.length !== 0 &&
                      props.transactions.bids[0].saleAmtPerUnit === ""
                    }
                    value={props.transactions.bids[0].saleAmtPerUnit}
                    placeholder={props.texts.PLS_ETR_SALES_AMT}
                    onChange={(e  ) => {
                      updateDecimalInputOnState(
                          e.target.value,
                          8,
                          "saleAmtPerUnit",
                          "JD",
                          props.setBidsTextValue
                      );
                      props.calculateSpreadAndMargin(props);
                    }}
                />
              </TableCell>
              {Array(compBids)
                  .fill(null)
                  .map((value, index) => (
                      <TableCell align="center">
                        <Input
                            type={"text"}
                            fullWidth
                            id="compSaleAmtPerUnit"
                            readOnly={props.actionType.action === "view"}
                            error={
                              props.errorFields.length !== 0 &&
                              props.transactions.bids[index + 1].saleAmtPerUnit === ""
                            }
                            value={props.transactions.bids[index + 1].saleAmtPerUnit}
                            onChange={(e) => {
                              updateDecimalInputOnState(
                                  e.target.value,
                                  8,
                                  "saleAmtPerUnit",
                                  `C${index + 1}`,
                                  props.setBidsTextValue
                              );
                              props.calculateSpreadAndMargin(props);
                            }}
                        />
                      </TableCell>
                  ))}
            </TableRow>
            <TableRow hover key="Currency" id={"Currency"}>
              <TableCell>
                <InputLabel>{props.texts.CURRENCY}</InputLabel>
              </TableCell>
              <TableCell align="center">
                <Input
                    disabled={true}
                    type={"text"}
                    fullWidth
                    id="currency"
                    readOnly={props.actionType.action === "view"}
                    placeholder={props.bids["currency"]}
                />
              </TableCell>
              {Array(compBids)
                  .fill(null)
                  .map((value, index) => (
                      <TableCell align="center">
                        <Input
                            readOnly={props.actionType.action === "view"}
                            disabled={true}
                            type={"text"}
                            fullWidth
                            id="currency"
                            placeholder={props.bids["currency"]}
                        />
                      </TableCell>
                  ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
  );
}

export default CompetitorInformation;